<template>
  <div class="col-12">
    <div class="card">
      <div class="grid">
        <ContactoCuentaPrincipal class="col-12 md:col-6" />
        <ContactosFacturacion class="col-12 md:col-6" />
        <OtrosContactos class="col-12" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactoCuentaPrincipal from "./components/ContactoCuentaPrincipal.vue";
// import ContactosFacturacion from "./components/ContactosFacturacion.vue";
// import OtrosContactos from "./components/OtrosContactos.vue";
import { GET_CLIENTE } from "@/graphQLQueries/ClienteQueries";
import { GET_LISTA_USUARIOS_VIEW } from "@/graphQLQueries/UsuarioQueries";

export default {
  name: "DatosContacto",
  components: {
    ContactoCuentaPrincipal,
    // ContactosFacturacion,
    // OtrosContactos,
  },
  data() {
    return {
      cliente: {},
      users: [],
    }
  },
  apollo: {
    cliente: {
      query: GET_CLIENTE,
      variables() {
        return {
          idLegal: this.$store.state.clienteIdLegal,
          idioma: this.$i18n.locale,
        };
      },
      update({ cliente }) {
        return cliente;
      },
    }
  },
  created(){
    this.loadUsers();
  },
  watch:{
    stepData(){
      this.loadUsers();
    }
  },
  methods: {
    async loadUsers(){
      let filters = [];
      
      filters = ["cliente.id~eq="+this.cliente.id,"tipo~eq=cliente"]
      if (this.$store.state.clienteIdLegal){
        await this.$apollo
          .query({
          query: GET_LISTA_USUARIOS_VIEW,
          variables: {
            filter: filters,
            sort: null,
            page: 0,
            size: 10,
          }
        })
        .then((data) => {
          this.users = data.data.listaUsuariosView.results;
        })
        .catch((exception) => {
          console.log(exception)
        });
      }
    },
  }
};
</script>

<style scoped>
</style>